import { useMemo, useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  createColumn,
  ColumnType,
  get as TableGetter,
  RowTypeConstant,
  HeaderCellTypeConstant,
} from "../../subComponents/table";
import { TasksStyleV1 } from "../../../styles/tasksStyle";

const useStyles = makeStyles(TasksStyleV1({}));

const NO_TASKS_MESSAGE = 'There are no tasks in your queue. Please check back later!';

const Colums = [
  createColumn({
    key: "OrderId",
    label: "Order ID",
    type: ColumnType.jsx,
    width: 120,
    hideSort: false,
  }),
  createColumn({
    key: "PatientName",
    label: "Patient Name",
    type: ColumnType.string,
    width: 160,
  }),
  createColumn({
    key: "OrderStatus",
    label: "Item Status",
    tooltip: "Item Status",
    type: ColumnType.string,
    width: 110,
  }),
  createColumn({
    key: "Storefront",
    label: "Storefront",
    type: ColumnType.string,
    width: 120,
  }),
  createColumn({
    key: "ProductName",
    label: "Product Name",
    type: ColumnType.string,
    width: 220,
  }),
  createColumn({
    key: "formattedCreatedAt",
    label: "Task Created Date", // "Task Created...",
    tooltip: "Task Created Date",
    type: ColumnType.date,
    width: 140,
  }),
  createColumn({
    key: "TaskType",
    label: "Task Type",
    tooltip: "Task Type",
    type: ColumnType.string,
    width: 180,
  }),
  createColumn({
    key: "TaskStatus",
    label: "Task Status", // "Task St...",
    tooltip: "Task Status",
    type: ColumnType.string,
    width: 90,
  }),
];

const LoadingRows = [
  {
    key: 1,
  },
  {
    key: 2,
  },
  {
    key: 3,
  },
];

const RowTypeCollection = new Map([
  [false, RowTypeConstant.regularWithLightBackground],
  [true, RowTypeConstant.regular],
]);

/**
 * @param {number} index
 * @returns {RowTypeConstant.regular | RowTypeConstant.regularWithLightBackground}
 */
const pickRowType = (index) => {
  const isOdd = Boolean(index % 2);
  return RowTypeCollection.get(isOdd);
};

/**
 * @returns {React.JSX.Element}
 */
const NoTasks = () => (
  <div className='flex flex-fill justify-content-center p-t-6 p-l-6 p-r-6'>
    {NO_TASKS_MESSAGE}
  </div>
);

/**
 * @param {{
 *    tasksInfo: {
 *      data: {
 *        Id: string,
 *        OMSOrderId: string,
 *        TaskStatus: string,
 *        ProductList: string[],
 *      }[],
 *      called: boolean,
 *      loading: boolean,
 *    };
 *    handleRouteChange: (data: { userId: string, orderId: string, taskId: string }) => boolean;
 *    onRefresh: () => void;
 * }} props
 * @returns {React.JSX.Element}
 */
export const Listing = ({
  tasksInfo = {},

  // action
  handleRouteChange: goToDetails = () => { },
}) => {
  const Table = TableGetter(1);
  const classes = useStyles();

  const tasks = useMemo(() => {
    return tasksInfo?.data
      .map((task, index) => ({
        ...task,
        OrderId: (
          <div className="flex align-items-center color-primary tracking-wide bold underline">
            {`${task?.OMSOrderId}`}
          </div>
        ),
        ProductName: task.ProductList.join(", "),
        type: pickRowType(index),
      }));
  }, [tasksInfo]);

  const handleRowClick = useCallback((task = {}) => {
    const taskQuery = {
      taskId: task.Id,
      orderId: task.OMSOrderId,
      userId: task.PatientId,
    };
    goToDetails(taskQuery);
  }, []);

  const isLoading = useMemo(() => {
    if (!tasksInfo.called) {
      return true;
    }

    if (tasksInfo.data.length) {
      return false;
    }

    return tasksInfo.loading;
  }, [tasksInfo]);

  const hasNoTask = useMemo(() => {
    if (tasksInfo.called && !tasksInfo.loading && tasksInfo.data.length === 0) {
      return true;
    }
    return false;
  }, [tasksInfo]);

  return (
    <div
      className={`${classes.tasksListing} flex flex-column flex-fill overflow-hidden scroll-y-auto`}
    >
      <Table
        columns={Colums}
        rows={tasks}
        loading={isLoading}
        loadingRows={LoadingRows}
        filterBy={""}
        stickyHeader
        headerVersion={HeaderCellTypeConstant.v2}
        handler={{ onRowClick: handleRowClick }}
      />

      {
        hasNoTask && <NoTasks />
      }
    </div>
  );
};

export default Listing;
